import { Link } from 'react-router-dom';
import { Modal } from '../ui';
import { LoginWeb2 } from './web2';
import { LoginWeb3 } from './web3';

interface LoginModalProps {
   isOpen: boolean;
   onClose: () => void;
}

export function LoginModal({ isOpen, onClose }: LoginModalProps) {
   return (
      <Modal
         className=""
         onClose={onClose}
         active={isOpen}
         transparent
         darkBackground>
         <div className="flex gap-3 wrap">
            <div className="flex flex-col box bg-gray gap-4 ">
               <LoginWeb2 />
            </div>
            <div className="flex flex-col box gap-4  bg-pattern">
               <LoginWeb3 header />
            </div>
         </div>
      </Modal>
   );
}
